import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("pages", {
    registration: "Registration",
    lobby: "Lobby",
    halls: "Halls",
    broadcast: "Broadcast",
    quiz: "Quiz",
    program: "Program",
    members: "Members",
    shop: "Prizes shop",
    profile: "Member profile",

    actions: "Actions",
    addPage: "Add page",
    openByDefault: "Open by default",
    openByDefaultTooltip: "Which page will open first when loading the platform for users from each participation format?",
    openForMembers: "Open for members",
    openForMembersTooltip: "What member format will this page be viewable for?",
    pageName: "Page title",
    needDifferentPlayerVersion: "To customize the page, you need a different version of the player",
});
